import ExpandLess from '@mui/icons-material/ExpandLess';
import ExpandMore from '@mui/icons-material/ExpandMore';
import { Button, Collapse, Typography } from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation, useNavigate } from 'react-router-dom';
import { SidebarItem } from '../../../hooks/useSidebarItems';

interface SidebarItemComponentProps {
  item: SidebarItem;
  isSubItem?: boolean;
  open: boolean;
  classes: any;
  isExpanded: boolean;
  toggleSubMenu: (itemId: string) => void;
}

export const SidebarItemComponent: React.FC<SidebarItemComponentProps> = ({ item, isSubItem = false, open, classes, isExpanded, toggleSubMenu }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();

  if (!item.enable) {
    return null;
  }

  const hasSubItems = item.subItems && item.subItems.length > 0;
  const enabled = item.isExtract ? item.path === location.pathname : item.path ? location.pathname.includes(item.path) : false;
  const Icon = typeof item.icon === 'string' ? null : item.icon;
  const buttonClasses = [classes.MenuButton, enabled && classes.MenuButtonActive, isSubItem && classes.MenuButtonSub, item.isLogout && classes.MenuButtonLogout]
    .filter(Boolean)
    .join(' ');

  const iconElement = (
    <>
      {typeof item.icon === 'string' ? (
        <img src={item.icon} height={24} width={24} alt={item.id} />
      ) : Icon ? (
        <Icon style={{ fontSize: 24, color: 'var(--Base-White, #FFF)' }} />
      ) : null}
    </>
  );

  if (hasSubItems) {
    return (
      <React.Fragment key={item.id}>
        <Button 
          onClick={() => {
            toggleSubMenu(item.id);
            if (item.path) {
              navigate(item.path);
            }
          }} 
          className={buttonClasses}
        >
          {iconElement}
          {open && <Typography className={classes.TextItem}>{t(item.label)}</Typography>}
          {open && (isExpanded ? <ExpandLess /> : <ExpandMore />)}
        </Button>
        <Collapse in={isExpanded} timeout="auto" unmountOnExit className={classes.Collapse}>
          {item.subItems?.map((subItem) => (
            <SidebarItemComponent key={subItem.id} item={subItem} isSubItem={true} open={open} classes={classes} isExpanded={false} toggleSubMenu={toggleSubMenu} />
          ))}
        </Collapse>
      </React.Fragment>
    );
  }

  return (
    <Button
      key={item.id}
      className={buttonClasses}
      onClick={() => {
        if (item.onClick) {
          item.onClick();
        }
        if (item.path) {
          navigate(item.path);
        }
      }}
    >
      {iconElement}
      {open && <Typography className={classes.TextItem}>{t(item.label)}</Typography>}
    </Button>
  );
};
